export const ENERGY_PRICE = 0.4175; // average price of electricity in Germany in the second half of 2023 in EUR/kWh
export const ENERGY_PRICE_SELLING = 0.08; // average price for selling electricity in Germany in EUR/kWh

export const CO2_EMISSIONS_PER_KWH = 0.380; // average CO2 emissions per kWh in Germany in 2023 in tons CO2/kWh
export const CO2_EMISSIONS_PER_FLIGHT = 0.299; // average CO2 emissions of a flight from Dortmund (DTM) to Palma de Mallorca (PMI) in 2023 in tons CO2
export const CO2_UPTAKE_PER_TREE = 0.02462; // average CO2 uptake of a tree in Germany in tons CO2/year
export const CO2_EMISSIONS_COMBUSTER_PER_KM = 0.00237; // average CO2 emissions per km of a gasoline car in Germany in tons CO2/km

export const JAZ = 3.5 // average JAZ (Jahresarbeitszahl) of air heat pumps in Germany

export const HEATING_HOURS = 2000 // average heating hours in Germany per year

export const HEATING_PERFORMANCE_NEW_BUILDING = 0.04 // average heating performance needed in Germany in kW/m² (new building)
export const HEATING_PERFORMANCE_OLD_RENOVATED = 0.08 // not used now, average heating performance needed in Germany in kW/m² (old building with renovated insulation)

export const HEATING_PERFORMANCE_BEFORE_1970 = 0.1 // average heating performance needed in Germany in kW/m² (build before 1970)
export const HEATING_PERFORMANCE_1971_TO_1995 = 0.065 // average heating performance needed in Germany in kW/m² (build 1971-1995)
export const HEATING_PERFORMANCE_1996_TO_2000 = 0.055 // average heating performance needed in Germany in kW/m² (build 1996-2000)
export const HEATING_PERFORMANCE_AFTER_2000 = 0.04 // average heating performance needed in Germany in kW/m² (build after 2000)

export const GAS_AVARAGE_CONSUMPTION = 160 // average gas consumption in Germany per year in kWh/m² (includes water heating)
export const GAS_CO2_EMISSIONS_PER_KWH = 0.209 // average CO2 emissions per kWh of gas in Germany in tons CO2/kWh
export const GAS_PRICE = 0.1141 // average price of gas in Germany in the second half of 2023 in EUR/kWh

export const COOLING_HOURS = 200 // average cooling hours in Germany per year

export const COOLING_PERFORMANCE_LOW = 0.06 // average cooling performance needed in Germany in kW/m² (good insulation and low solar radiation)
export const COOLING_PERFORMANCE_HIGH = 0.1 // not used now, average cooling performance needed in Germany in kW/m² (bad insulation and high solar radiation)

export const E_CAR_CONSUMPTION = 0.2 // average consumption of an electric car in Germany in kWh/km

export const E_CAR_KM_PER_YEAR = 10000 // average distance driven by an electric car in Germany per year

export const AREA_SINGLE_HOUSE = 150 // average area of a single house in Germany in m²
export const AREA_ROW_HOUSE = 115 // average area of a row house in Germany in m²
export const AREA_SEMI_DETACHED_HOUSE = 135 // average area of a semi-detached house in Germany in m²
export const AREA_MULTI_FAMILY_HOUSE = 900 // average area of a multi-family house with 10 flats in Germany in m²
